
function strlen(str) {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
      len++;
    } else {
      len += 2;
    }
  }
  return len;
}

export const ValidateType = {
  REQUIRED: 'required',
  CHAR: 'char',
  MAX_LENGTH: 'max-length',
  POSITIVE_NUMBER: 'number',
  NUM_RANGE: 'num-range',
  STR_RANGE: 'str-range',
  NOT_EQUALS: 'not-equals',
  CHAR_TYPE: 'char-type'
};

export const Validators = {
  [ValidateType.REQUIRED]: function(value, param) {
    if (value == null || value === '') {
      return false;
    }
    return true;
  },
  [ValidateType.CHAR]: function(value, param) {
    return /^[_a-zA-Z0-9\u4e00-\u9fa5]+$/.test(value);
  },
  [ValidateType.MAX_LENGTH]: function(value, param) {
    return strlen(value) <= param.limit;
  },
  [ValidateType.POSITIVE_NUMBER]: function(value, param) {
    return /^[1-9][0-9]*$/.test(value);
  },
  [ValidateType.NUM_RANGE]: function(value, param) {
    value = Number(value);
    return value >= param.min && value <= param.max;
  },
  [ValidateType.STR_RANGE]: function(value, param) {
    return strlen(value) >= param.min && strlen(value) <= param.max;
  },
  [ValidateType.NOT_EQUALS]: function(value, param) {
    return value !== param.value;
  },
  [ValidateType.CHAR_TYPE]: function(value, param) {
    return /^[0-9a-zA-Z]+$/.test(value);
  }
};

export const ValidationHelper = {
  attach: function(ruleConfigs) {
    return function(rule, value, callback) {
      for (let i = 0; i < ruleConfigs.length; i++) {
        let config = ruleConfigs[i];

        if (config.callback) {
          config.callback(value, callback);
          break;
        }

        if (!Validators[config.type](value, config.param)) {
          callback(new Error(config.message));
          break;
        }
      }
      callback();
    };
  }
};

export const backwardSupportValidate = function(rule, value, callback) {
  let message = null;
  if (value.indexOf('&') !== -1) {
    message = '不支持&字符 请重新输入';
  }
  if (message) {
    callback(message);
  } else {
    callback();
  }
};



// WEBPACK FOOTER //
// ./src/common/ValidationUtils.js